import apiClient from './client';

export interface QuizVocabulary {
  id: number;
  question: string;
  answer: string;
  score: number;
  phase: number;
  options?: string[]; // Only for MULTIPLE_CHOICE mode
}

export interface StartQuizDto {
  mode: 'FLASHCARD' | 'MULTIPLE_CHOICE' | 'TEST';
}

export interface QuizSession {
  sessionId: string;
  vocabularies: QuizVocabulary[];
}

export interface SubmitAnswerDto {
  sessionId: string;
  vocabId: number;
  userAnswer: string;
  timeTaken: number; // milliseconds
}

export interface AnswerResult {
  correct: boolean;
  correctAnswer: string;
  oldScore: number;
  oldPhase: number;
  newScore: number;
  newPhase: number;
}

export interface SessionResult {
  sessionId: string;
  totalWords: number;
  correctAnswers: number;
  incorrectAnswers: number;
  successRate: number;
  answers: Array<{
    vocabId: number;
    question: string;
    answer: string;
    userAnswer: string;
    correct: boolean;
    oldPhase: number;
    newPhase: number;
    oldScore: number;
    newScore: number;
  }>;
}

export interface ProgressItem {
  vocabId: number;
  question: string;
  answer: string;
  score: number;
  phase: number;
  lastSeen: string | null;
}

export const quizApi = {
  startSession: async (courseId: number, dto: StartQuizDto): Promise<QuizSession> => {
    const { data } = await apiClient.post(`/quiz/courses/${courseId}/start`, dto);
    return data;
  },

  submitAnswer: async (dto: SubmitAnswerDto): Promise<AnswerResult> => {
    const { data } = await apiClient.post('/quiz/answer', dto);
    return data;
  },

  getSessionResults: async (sessionId: string): Promise<SessionResult> => {
    const { data } = await apiClient.get(`/quiz/sessions/${sessionId}/results`);
    return data;
  },

  getProgress: async (courseId: number): Promise<ProgressItem[]> => {
    const { data } = await apiClient.get(`/quiz/courses/${courseId}/progress`);
    return data;
  },
};
